import deleteIcon from '../../assets/images/icons/delete.png';
import viewIcon from '../../assets/images/icons/view.png';
import editIcon from "../../assets/images/icons/edit.png";
const AdminActions = () =>{

    return(
         
        <div style={{display:"flex", justifyContent:"space-between", maxWidth:"75px"}}>
            <a className="admin-actions-btn delete-btn" href="#deleteModal" data-toggle="modal"><img className="img-icon" src={deleteIcon} alt="delete icon"/></a>
            <a className="admin-actions-btn edit-btn" href="#editModal" data-toggle="modal"><img className="img-icon"  src={editIcon} alt="edit icon"/></a>
            <a className="admin-actions-btn view-btn" href="#viewModal" data-toggle="modal"><img className="img-icon"  src={viewIcon} alt="view icon"/></a>
        </div>
        
    );
   
}
export default AdminActions;